"use client"

import {useEffect, useState} from "react";
import {Link, usePathname} from "@pata/i18n";
import {useLocale} from "next-intl";

export type Props = {
    id: string | number;
    title: string;
    url: string;
}

export default function MenuItem(props: Props) {
    const isExternalLink = (url: string) => url.startsWith('http://') || url.startsWith('https://')
    const isActiveMenu = (pathname: string) => {
        return pathname + window.location.hash === props.url;
    }
    
    const [isActive, setActive] = useState(false);
    const pathname = usePathname();
    const locale = useLocale();
    
    useEffect(() => {
        setActive(isActiveMenu(pathname));
    }, [pathname, locale]);
    
    return (
        <li id={`${props.id ? `menu-item-${props.id}` : ""}`}
            className={`menu-item ${props.id ? `menu-item-${props.id}` : ""} ${isActive ? `current-menu-item page_item page-item-${props.id} current_page_item` : ''}`}>
            {isExternalLink(props.url)
                ? <Link target="_blank" rel="noopener noreferrer" href={props.url}>{props.title}</Link>
                : <Link href={props.url}>{props.title}</Link>
            }
        </li>
    )
}